import React, { useMemo, useState } from 'react';
import { deleteAccount } from '../../utils/accountDeletionApi';

const DELETE_CONFIRMATION_WORD = 'delete';

const DeleteAccountSection = ({ onDeleted }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [confirmationDraft, setConfirmationDraft] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const canDelete = useMemo(
    () => confirmationDraft.trim().toLowerCase() === DELETE_CONFIRMATION_WORD,
    [confirmationDraft]
  );

  const openConfirmation = () => {
    setIsExpanded(true);
    setConfirmationDraft('');
    setErrorMessage('');
  };

  const closeConfirmation = () => {
    if (isDeleting) return;
    setIsExpanded(false);
    setConfirmationDraft('');
    setErrorMessage('');
  };

  const handleDeleteAccount = async () => {
    if (isDeleting || !canDelete) return;

    setIsDeleting(true);
    setErrorMessage('');
    try {
      await deleteAccount({ confirmationText: confirmationDraft });
      await onDeleted?.();
      setIsDeleting(false);
    } catch (error) {
      console.error('[DeleteAccountSection] account deletion failed', error);
      setErrorMessage(error?.message || 'Could not delete account.');
      setIsDeleting(false);
    }
  };

  if (!isExpanded) {
    return (
      <button
        className="user-menu-action user-menu-action-danger"
        onClick={openConfirmation}
        type="button"
      >
        Delete account
      </button>
    );
  }

  return (
    <div className="user-menu-delete-panel" role="group" aria-label="Delete account confirmation">
      <p className="user-menu-delete-warning">
        This is permanent. Type <strong>delete</strong> to remove your account, profile, and saved
        cards.
      </p>
      <input
        className="user-menu-input"
        type="text"
        value={confirmationDraft}
        onChange={(event) => setConfirmationDraft(event.target.value)}
        placeholder='Type "delete"'
        autoComplete="off"
        spellCheck="false"
        disabled={isDeleting}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            handleDeleteAccount();
          }
        }}
      />
      {errorMessage && <div className="user-menu-error">{errorMessage}</div>}
      <div className="user-menu-edit-actions">
        <button
          className="user-menu-action user-menu-action-secondary"
          onClick={closeConfirmation}
          type="button"
          disabled={isDeleting}
        >
          Cancel
        </button>
        <button
          className="user-menu-action user-menu-action-danger"
          onClick={handleDeleteAccount}
          type="button"
          disabled={!canDelete || isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete forever'}
        </button>
      </div>
    </div>
  );
};

export default DeleteAccountSection;
